export default {
	/**
	 * @description 配置显示在浏览器标签的title
	 */
	title: "草本投资",
	/**
	 * @description token在Cookie中存储的天数，默认7天
	 */
	cookieExpires: 7,
	/**
	 * @description 是否使用国际化，默认为false
	 *              如果不使用，则需要在路由中给需要在菜单中展示的路由设置meta: {title: 'xxx'}
	 *              用来在菜单中显示文字
	 */
	useI18n: false,
	/**
	 * @description api接口请求基础路径
	 */
	apiUrl: {
		dev: "http://api.caobentz.cn/", //开发API接口
		pro: "http://api.caobentz.cn/", //正式API接口	
	},
	/**
	 * @description 渠道ID:1,官方
	 */
	channelID: "cbtz",
	/**
	 * @description 企业官网模板编号
	 */
	websiteTemplateCode: "WT1",
	/**
	 * @description 来源:0,无;1,官网pc;2,官网移动端;3,app;4,小程序;5,公众号;99,管理后台
	 */
	sourceFlag: "1",
	/**
	 * @description 是否加密:1是;0否
	 */
	cryptFlag: 1,
	/**
	 * @description 加密密钥
	 */
	encryptKey: "yfzX8jra6VmWC4spyXwqDiSc7AREPvkh",
	/**
	 * @description 分页条数
	 */
	pageNum: 20,
	/**
	 * @description 默认打开的首页的路由name值，默认为index
	 */
	homeName: "index",
	/**
	 * @description 默认语言
	 */
	defaultLanguage: "zh-CN",
	/**
	 * 打印日志状态:0,不打印;1,打印
	 */
	consoleLogFlag: 1,
};
